import { Check, ChevronLeft, SearchMd } from "@untitled-ui/icons-react";
import type { ReactNode } from "react";

import Button from "@/components/forms/Button";
import Input from "@/components/forms/Input";

type GroupSubPageHeaderProps = {
  title: string;
  onBack: () => void;
  onConfirm?: () => void;
  isConfirmLoading?: boolean;
  showSearch?: boolean;
  onToggleSearch?: () => void;
  searchQuery?: string;
  onSearchChange?: (value: string) => void;
  searchPlaceholder?: string;
  endSlot?: ReactNode;
};

export default function GroupSubPageHeader({
  title,
  onBack,
  onConfirm,
  isConfirmLoading,
  showSearch,
  onToggleSearch,
  searchQuery,
  onSearchChange,
  searchPlaceholder,
  endSlot,
}: GroupSubPageHeaderProps) {
  return (
    <div className="border-b px-6">
      <div className="flex items-center gap-3 py-4">
        <Button color="tertiary-gray" square onClick={onBack}>
          <ChevronLeft className="size-5 text-gray-700 rtl:rotate-180" />
        </Button>
        {showSearch && onSearchChange ? (
          <Input
            startIcon={<SearchMd className="size-5" />}
            placeholder={searchPlaceholder}
            value={searchQuery ?? ""}
            onChange={(e) => onSearchChange(e.target.value)}
            className="min-w-0 flex-1"
            autoFocus
          />
        ) : (
          <span className="min-w-0 flex-1 text-lg font-semibold text-gray-900">
            {title}
          </span>
        )}
        <div className="flex items-center gap-3">
          {onToggleSearch && (
            <Button
              color="tertiary-gray"
              size="lg"
              square
              onClick={onToggleSearch}
            >
              <SearchMd className="size-5 text-gray-600" />
            </Button>
          )}
          {endSlot}
          {onConfirm && (
            <Button
              color="tertiary-gray"
              size="lg"
              square
              onClick={onConfirm}
              isLoading={isConfirmLoading}
            >
              <Check className="size-5 text-gray-600" />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
